const { createContext } = require("react");

const noteContext=createContext();
export default noteContext